import { render, staticRenderFns } from "./TabWaiting.vue?vue&type=template&id=660e65ca&"
import script from "./TabWaiting.vue?vue&type=script&lang=js&"
export * from "./TabWaiting.vue?vue&type=script&lang=js&"
import style0 from "./TabWaiting.vue?vue&type=style&index=0&id=660e65ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports